import { env } from '../environment';

export const ROUTER_BASENAME = env.ROUTER_BASENAME!;
export const MY_APPS = '/myapps';
export const INSTALL = '/install';
export const INSTALLATIONS = 'installations';
export const MY_CONNECT_APPS = `${MY_APPS}/connect`;

/**
 * @param relativePath Path to join to my apps router path (no leading slash)
 */
export function myAppsRelativePath(relativePath: string): string {
  return `${ROUTER_BASENAME}${MY_APPS}/${relativePath}`;
}
